import { Typography } from "@material-ui/core";
import CardSection from "components/styledComponents/CardSection";
import StrikeThrough from "components/generics/StrikeThrough";
import Underline from "components/generics/Underline";
import BulletCircle from "assets/web/BulletCircle.svg";
import ReactMarkdown from "components/generics/ReactMarkdown";
import { createUseStyles } from "react-jss";
import rehypeRaw from 'rehype-raw'

const useStyles = createUseStyles({
    leftSection: {},
    featureList: {
        display: "flex",
        alignItems: "center",
        "& svg":{
            width: "auto",
        },
        "& p":{
            width: "95%",
        }
    },
    strikeTitle: {
        "&::after": {
            top: "35%",
        }
    },
    featureTitle: {
        marginTop: "-35px!important"
    },
    rightSection:{},
    thirdSectionContainer:{},
    "@media screen and (max-width:760px)": {
        strikeTitle: {
            "&::after": {
                top: "25%",
            }
        },
        leftSection: {
            alignItems: "flex-start",
        },
        rightSection:{
            marginTop: 0,
        },
        thirdSectionContainer:{
            padding: "0 10px",
        },
        featureTitle:{
            marginTop: "30px!important",
        },
        featureList: {
            alignItems: "flex-start",
            '& svg': {
                marginTop: "5px",
            }
        }
    }
})

function TeacherHeader({
    data,
}) {
    const classes = useStyles();

    return (
        <CardSection
            leftWidth={50}
            leftSectionClassName={classes.leftSection}
            rightSectionClassName={classes.rightSection}
            leftSection={
                <>
                    <StrikeThrough>
                        <Typography
                            variant="h1"
                        >
                            {data.striked_title}
                        </Typography>
                    </StrikeThrough>
                    <Underline>
                        <Typography variant="h1">
                            {data.title}
                        </Typography>
                    </Underline>
                    <ReactMarkdown
                        children={data.description}
                        rehypePlugins={[rehypeRaw]}
                        // skipHtml={true}
                    />
                </>
            }
            rightSection={
                <>
                    <img
                        src={data.image}
                        alt="SQ"
                    />
                </>
            }
            thirdSection={
                <div className={classes.thirdSectionContainer}>
                    <Typography
                        variant="h5"
                        // className="mtb20"
                        className={classes.featureTitle}
                    >
                        {data.coach_features.title}
                    </Typography>
                    <div>
                        {data.coach_features.features.map((item, index) => (
                            <div
                                key={index}
                                className={classes.featureList}
                            >
                                <BulletCircle />
                                <Typography
                                    variant="body2"
                                    className="mlr10"
                                >
                                    {item.title}
                                </Typography>
                            </div>
                        ))}
                    </div>
                </div>
            }
        />
    )
}

export default TeacherHeader;